import React from "react";

export default function FooterSociallinks() {
    return (
        <>
            {/* Footer Text */}
            <div className="row text-gray">
                <div className="col-md-4 col-lg-3">
                    <b>© GetBiz Solutions {new Date().getFullYear()}.</b>
                    <div className="footer-legal-links mt-1" style={{ fontSize: "0.9rem" }}>
                        <a href="/privacy-policy/" aria-label="Privacy Policy">Privacy Policy</a>
                        {" · "}
                        <a href="/terms-of-service/" aria-label="Terms of Service">Terms of Service</a>
                        {" · "}
                        <a href="/data-deletion/" aria-label="Data Deletion">Data Deletion</a>
                    </div>
                </div>
                <div className="col-md-7 offset-md-1 offset-lg-2 clearfix">
                    {/* Social Media Icons */}
                    <a
                        href="https://www.facebook.com/getbizsolutions"
                        rel="noopener"
                        target="_blank"
                        aria-label="GetBiz Solutions on Facebook"
                        style={{ fontSize: '1.5rem', marginRight: '16px' }}
                    >
                        <i className="fa-facebook" />
                    </a>
                    <a
                        href="https://www.youtube.com/@getbiz_solutions"
                        rel="noopener"
                        target="_blank"
                        aria-label="GetBiz Solutions on Youtub"
                        style={{ fontSize: '1.5rem', marginRight: '16px' }}
                    >
                        <i className="fa-youtube" />
                    </a>
                    <a
                        href="https://www.pinterest.com/getbiz_solutions"
                        rel="noopener"
                        target="_blank"
                        aria-label="GetBiz Solutions on Pinterest"
                        style={{ fontSize: '1.5rem', marginRight: '16px' }}
                    >
                        <i className="fa-pinterest" />
                    </a>
                    <a
                        href="https://www.linkedin.com/company/getbiz-solutions"
                        rel="noopener"
                        target="_blank"
                        aria-label="GetBiz Solutions on Linkedin"
                        style={{ fontSize: '1.5rem', marginRight: '16px' }}
                    >
                        <i className="fa-linkedin" />
                    </a>
                    <a
                        href="https://www.instagram.com/getbiz_solutions"
                        rel="noopener"
                        target="_blank"
                        aria-label="GetBiz Solutions on Instagram"
                        style={{ fontSize: '1.5rem', marginRight: '16px' }}
                    >
                        <i className="fa-instagram" />
                    </a>
                    <a
                        href="https://x.com/Getbiz_Solution"
                        rel="noopener"
                        target="_blank"
                        aria-label="GetBiz Solutions on Twitter"
                        style={{ fontSize: '1.5rem', marginRight: '16px' }}
                    >
                        <i className="fa-twitter" />
                    </a>
                    {/* <a
                        href="#"
                        rel="noopener"
                        target="_blank"
                        style={{ fontSize: '1.5rem', marginRight: '16px' }}
                    >
                        <i className="fa-dribbble" />
                    </a> */}

                    {/* Back to Top Link */}
                    <div className="local-scroll float-end mt-n20 mt-sm-10">
                        <a href="#top" className="link-to-top">
                            <i className="mi-arrow-up size-24" />
                            <span className="visually-hidden">Scroll to top</span>
                        </a>
                    </div>
                    {/* End Back to Top Link */}
                </div>

            </div>
            {/* End Footer Text */}
        </>
    );
}
